module.exports = __webpack_public_path__ + "static/gallery1-e364685de2a2a89eeef42c5c0a5c99fa.jpg";